<template>
  <div class="home">
    <div class="mian mainHome">
      <div class="wrap">
        <!-- 新闻中心 -->
        <div class="homeNews">
          <div class="main_title">
            <h3>新 闻 中 心</h3>
            <h4>NEWS CENTER</h4>
          </div>
          <div class="homeNewsHd" style="text-align: center">
            <span
              class="homeNewsHdInner"
              :class="{ active: activeNewsHd == index }"
              v-for="(item, index) in newsHdList"
              :key="index"
              @mouseenter="mouseenterNewsHd(index)"
            >
              <a :href="item.url" target="_balnk">{{ item.title }}</a>
            </span>
          </div>
          <div class="PressCenter" style="height: 380px; clear: both; width: 1200px; margin: 0 auto">
            <div class="homePhotoNew">
              <div class="PhotoNew1" v-for="(item, index) in homePhotoNew" :key="index">
                <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                  <div class="timeDiv">
                    <h4>{{ dayjs(item.publishDate).format('DD') }}</h4>
                    <div class="timeDivYear">{{ dayjs(item.publishDate).format('YYYY-MM') }}</div>
                  </div>
                  <img :src="item.thumb1" alt="" />
                  <h4 class="h4title">{{ item.title }}</h4>
                  <p></p>
                  <!-- <span>MORE+</span> -->
                </a>
                <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                  <div class="timeDiv">
                    <h4>{{ dayjs(item.publishDate).format('DD') }}</h4>
                    <div class="timeDivYear">{{ dayjs(item.publishDate).format('YYYY-MM') }}</div>
                  </div>
                  <img :src="item.thumb1" alt="" />
                  <h4 class="h4title">{{ item.title }}</h4>
                  <p></p>
                  <!-- <span>MORE+</span> -->
                </a>
              </div>
            </div>
            <div class="homeNewRight">
              <ul class="news_list" v-if="activeNewsHd == 0">
                <li
                  v-for="(item, index) in newsRight01"
                  :key="index"
                  :class="{ active: activeNewli == index }"
                  @mouseenter="mouseenterst(index)"
                >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                  </div>
                </li>
              </ul>

              <ul class="news_list" v-if="activeNewsHd == 1">
                <li
                  v-for="(item, index) in newsRight02"
                  :key="index"
                  :class="{ active: activeNewli == index }"
                  @mouseenter="mouseenterst(index)"
                >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="news_list" v-if="activeNewsHd == 2">
                <li
                  v-for="(item, index) in newsRight03"
                  :key="index"
                  :class="{ active: activeNewli == index }"
                  @mouseenter="mouseenterst(index)"
                >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                    <a v-else target="_blank" :href="`/detail/01510006/${item.entTArticleUuid}`">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="news_list" v-if="activeNewsHd == 3">
                <li
                  v-for="(item, index) in newsRight04"
                  :key="index"
                  :class="{ active: activeNewli == index }"
                  @mouseenter="mouseenterst(index)"
                >
                  <div class="homeNewList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="NewListTitle">
                        <h4>{{ item.title }}</h4>
                        <span class="newsTime">{{ dayjs(item.publishDate).format('YYYY-MM-DD') }}</span>
                      </div>
                      <p>
                        {{ item.artDesc | ellipsis }}
                        <span style="color: #ec6941">[查看详情]</span>
                      </p>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 精品工程 -->
        <div class="homeJpgc">
          <div class="main_title">
            <h3>精 品 工 程</h3>
            <h4>BOUTIQUE PROJECT</h4>
          </div>
          <div class="main2_1">
            <div class="swiper-container bannerPoint">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in homeJpgcList" :key="index">
                  <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                    <div class="pic">
                      <img class="img_c1" :src="item.thumb1" alt="" />
                    </div>
                    <div class="title">
                      <p class="single-line">{{ item.title }}</p>
                    </div>
                  </a>
                  <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                    <div class="pic">
                      <img class="img_c1" :src="item.thumb1" alt="" />
                    </div>
                    <div class="title">
                      <p class="single-line">{{ item.title }}</p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="swiper-button-prev swiper-button-prev-jpgc"></div>
            <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
            <div class="swiper-button-next swiper-button-next-jpgc"></div>
            <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
          </div>
          <div class="main2_m">
            <a href="/listPic/01530001"></a>
          </div>
        </div>
        <!-- 新闻列表 -->
        <div class="NewList">
          <div class="NewListL">
            <div class="newTitle">
              <div
                class="NewsLTitle"
                v-for="(item, index) in catalogList1"
                :key="index"
                @mouseenter="mouseenterNewsList(index)"
              >
                <a :href="item.url" :class="{ active: activeNewsList == index }">{{ item.title }}</a>
                <span class="span1" v-if="index < catalogList1.length - 1">/</span>
              </div>
              <span class="more" v-if="activeNewsList == 0">
                <a href="/list/01570001"> MORE+ </a>
              </span>
              <span class="more" v-if="activeNewsList == 1">
                <a href="/listPic/01520003"> MORE+ </a>
              </span>
            </div>
            <div class="NewsLInner">
              <ul class="newsInner" v-if="activeNewsList == 0">
                <li v-for="(item, index) in newsInner01" :key="index">
                  <div class="newsInnerList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="newsInner" v-if="activeNewsList == 1">
                <li v-for="(item, index) in newsInner02" :key="index">
                  <div class="newsInnerList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="NewListL2">
            <div class="newTitle">
              <div
                class="NewsLTitle"
                v-for="(item, index) in catalogList2"
                :key="index"
                @mouseenter="mouseenterNewsList2(index)"
              >
                <a :href="item.url" :class="{ active: activeNewsList2 == index }">{{ item.title }}</a>
                <span class="span1" v-if="index < catalogList2.length - 1">/</span>
              </div>
              <span class="more" v-if="activeNewsList2 == 0">
                <a href="/list/01570008"> MORE+ </a>
              </span>
              <span class="more" v-if="activeNewsList2 == 1">
                <a href="/list/01550001"> MORE+ </a>
              </span>
            </div>
            <div class="NewsLInner">
              <ul class="newsInner" v-if="activeNewsList2 == 0">
                <li v-for="(item, index) in newsInner03" :key="index">
                  <div class="newsInnerList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="newsInner" v-if="activeNewsList2 == 1">
                <li v-for="(item, index) in newsInner04" :key="index">
                  <div class="newsInnerList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="NewListL3">
            <div class="newTitle">
              <div
                class="NewsLTitle"
                v-for="(item, index) in catalogList3"
                :key="index"
                @mouseenter="mouseenterNewsList3(index)"
              >
                <a :href="item.url" :class="{ active: activeNewsList3 == index }">{{ item.title }}</a>
                <span class="span1" v-if="index < catalogList3.length - 1">/</span>
              </div>
              <span class="more" v-if="activeNewsList3 == 0">
                <a href="/list/01540002"> MORE+ </a>
              </span>
              <span class="more" v-if="activeNewsList3 == 1">
                <a href="/list/01560004"> MORE+ </a>
              </span>
            </div>
            <div class="NewsLInner">
              <ul class="newsInner" v-if="activeNewsList3 == 0">
                <li v-for="(item, index) in newsInner05" :key="index">
                  <div class="newsInnerList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                  </div>
                </li>
              </ul>
              <ul class="newsInner" v-if="activeNewsList3 == 1">
                <li v-for="(item, index) in newsInner06" :key="index">
                  <div class="newsInnerList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 中部banner -->
        <div class="homeBanner">
          <div class="swiper-container" id="homeBann">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item, index) in homeBannList" :key="index">
                <a target="_blank" :href="item.url">
                  <img class="swiper_img" :src="item.fileName" style="width: 100%" />
                </a>
              </div>
            </div>
            <div class="swiper-pagination swiper-pagination-homeBanner"></div>
          </div>
        </div>
        <!-- 新闻列表二 -->
        <div class="NewList">
          <div class="NewListL">
            <div class="newTitle">
              <div class="NewsLTitle">
                <a href="/list/01600001" target="_blank">综合专区</a>
              </div>
              <span class="more">
                <a href="/list/01600001" target="_blank"> MORE+ </a>
              </span>
            </div>
            <div class="NewsLInner" style="width: 353px; height: 222px; margin-top: 21px">
              <div class="NewsLInn1 NewsLInn" style="float: left">
                <a href="http://61.178.243.241:88/i6p" target="_blank">
                  <span></span>
                  <h4>综合项目管理平台</h4>
                </a>
              </div>
              <div class="NewsLInn2 NewsLInn" style="float: right">
                <a href="/list/01600003" target="_blank">
                  <span></span>
                  <h4>企业党建</h4>
                </a>
              </div>
              <div class="NewsLInn3 NewsLInn" style="float: left">
                <a href="/listPage/0161" target="_blank">
                  <span></span>
                  <!-- <div style="height:35px"></div> -->
                  <h4>监察举报</h4>
                </a>
              </div>
              <div class="NewsLInn4 NewsLInn" style="float: right">
                <a href="/list/01500007" target="_blank">
                  <span></span>
                  <h4>基层公司</h4>
                </a>
              </div>
            </div>
          </div>

          <div class="NewListL2">
            <div class="newTitle">
              <div class="NewsLTitle">
                <a href="/list/01600001" target="_blank">专题专栏</a>
              </div>
              <span class="more">
                <a href="/list/01600001" target="_blank"> MORE+ </a>
              </span>
            </div>

            <div class="NewsLInner">
              <ul class="newsInner">
                <li v-for="(item, index) in newsInner07" :key="index">
                  <div class="newsInnerList">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <h3>{{ item.title }}</h3>
                      <span class="newsInnerTime">{{ dayjs(item.publishDate).format('MM-DD') }}</span>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="NewListL3">
            <div class="newTitle">
              <div class="NewsLTitle">
                <a href="/listPic/01600005" target="_blank">企业宣传手册</a>
              </div>
              <span class="more">
                <a href="/listPic/01600005" target="_blank"> MORE+ </a>
              </span>
            </div>
            <div class="NewsLPaper">
              <div class="swiper-container Paper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in homenewPaper" :key="index">
                    <a v-if="item.url && item.url !== ''" target="_blank" :href="item.url">
                      <div class="Paperpic">
                        <img class="Paperimg" :src="item.thumb1" alt="" />
                      </div>
                    </a>
                    <a v-else target="_blank" :href="`/detail/${item.entTChannelUuid}/${item.entTArticleUuid}`">
                      <div class="Paperpic">
                        <img class="Paperimg" :src="item.thumb1" alt="" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="swiper-button-prev swiper-button-prev-Paper"></div>
              <div class="swiper-button-next swiper-button-next-Paper"></div>
            </div>
          </div>
        </div>
        <!-- 监督举报 -->
        <div class="homeReport">
          <a href="/listPage/0161" target="_blank"><img src="../assets/image/tiaofu.jpg" /></a>
        </div>
        <!-- 视频中心 走进七建 -->
        <div class="main6">
          <div class="main6_1">
            <div class="main6_left" style="float: left">
              <a href="/listPic/01510005" target="_blank">
                <img src="../assets/image/gsqj_20.png" />
                <div class="main6_left1">
                  <h4>视频中心</h4>
                  <h5>VIDEO CENTER</h5>
                  <span style="opacity: 1; right: 29px"></span>
                </div>
              </a>
            </div>
            <div class="main6_right main6_right_new" style="float: right">
              <img src="../assets/image/jjjbzx.jpg" />
              <!-- <a href="/list/01500001" target="_blank">
                <img src="../assets/image/gsqj_21.png">
                <div class="main6_right1">
                  <h4>走进七建</h4>
                  <h5>ABOUT US</h5>
                  <span style="opacity: 1; right: 29px;"></span>
                </div>
              </a> -->
            </div>
          </div>
        </div>
        <!-- 链接 -->
        <div class="main7">
          <div class="main7Inner" style="padding-left: 0">
            <div class="main7Div">
              <select onchange="javascript:window.open(this.options[this.selectedIndex].value)">
                <option value="">----集团内部链接----</option>
                <option value="https://www.baidu.com/">----集团内部链接----</option>
              </select>
            </div>
          </div>
          <div class="main7Inner">
            <div class="main7Div">
              <select onchange="javascript:window.open(this.options[this.selectedIndex].value)">
                <option value="">----甘肃建投内部链接----</option>
                <option value="">----甘肃建投内部链接----</option>
              </select>
            </div>
          </div>
          <div class="main7Inner">
            <div class="main7Div">
              <select onchange="javascript:window.open(this.options[this.selectedIndex].value)">
                <option value="">----友情链接----</option>
                <option value="">----友情链接----</option>
              </select>
            </div>
          </div>
          <div class="main7Inner" style="padding-right: 0; border-right: 0">
            <div class="main7Div">
              <select onchange="javascript:window.open(this.options[this.selectedIndex].value)">
                <option value="">----其他----</option>
                <option value="">----其他----</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Swiper from 'swiper'
import { picArticles, articles, getAdvert, picArticlesSecond, getAllArtListByParentUuid } from '@/api/common'
export default {
  name: 'home',
  data() {
    return {
      activeNewsHd: 0,
      activeNewli: 0,
      activeNewsList: 0,
      activeNewsList2: 0,
      activeNewsList3: 0,
      newsPlay1: 0,
      homeBannList: [],
      newsHdList: [
        {
          title: '集团要闻',
          url: '/list/01510001'
        },
        {
          title: '基层动态',
          url: '/list/01510002'
        },
        {
          title: '建投要闻',
          url: '/list/01510006'
        },
        {
          title: '公示公告',
          url: '/list/01510003'
        }
      ],
      catalogList1: [
        {
          title: '行业动态',
          url: '/list/01570001'
        },
        {
          title: '科技创新',
          url: 'listPic/01520003'
        }
      ],
      catalogList2: [
        {
          title: '学习园地',
          url: '/list/01570008'
        },
        {
          title: '党群工作',
          url: '/list/01550001'
        }
      ],
      catalogList3: [
        {
          title: '企业文化',
          url: '/list/01540002'
        },
        {
          title: '人力资源',
          url: '/list/01560004'
        }
      ],

      homePhotoNew: [],
      newsRight01: [],
      newsRight02: [],
      newsRight03: [],
      newsRight04: [],
      homeJpgcList: [],
      newsInner01: [],
      newsInner02: [],
      newsInner03: [],
      newsInner04: [],
      newsInner05: [],
      newsInner06: [],
      newsInner07: [],
      homenewPaper: [],
      homenewPaper2: [
        {
          thumb1: require('../assets/image/20170922055525209.jpg')
        },
        {
          thumb1: require('../assets/image/20170922055753238.jpg')
        },
        {
          thumb1: require('../assets/image/20190430063252857.jpg')
        }
      ]
    }
  },
  mounted() {
    this.PhotoNew()
    this.homeNews()
    this.bannerPoint()
    this.bannerImg()
    this.bannerNewPaper()
  },
  filters: {
    //超过100位显示 ...
    ellipsis: function (value) {
      if (!value) return ''
      if (value.length > 70) {
        return value.slice(0, 70) + '...'
      }
      return value
    }
  },
  methods: {
    PhotoNew() {
      var _this = this
      let dataPhotoNew = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01510004',
        pageNum: 1,
        pageSize: 2
      }
      picArticles(dataPhotoNew).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homePhotoNew = data.rows
        }
      })
    },
    //新闻中心
    homeNews() {
      var _this = this
      //集团要闻
      let data01 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01510001',
        pageNum: 1,
        pageSize: 7
      }
      articles(data01).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight01 = data.rows
        }
      })

      //基层动态
      let data02 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01510002',
        pageNum: 1,
        pageSize: 7
      }
      articles(data02).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight02 = data.rows
        }
      })

      //建投要闻
      let data03 = {
        entTApplicationUuid: _this.webIdGroup,
        // channelUuid: '01510006',
        channelUuid: '00190001',
        pageNum: 1,
        pageSize: 7
      }
      articles(data03).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight03 = data.rows
        }
      })

      //公示公告
      let data04 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01510003',
        pageNum: 1,
        pageSize: 7
      }
      articles(data04).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsRight04 = data.rows
        }
      })

      //行业动态
      let data05 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01570001',
        pageNum: 1,
        pageSize: 5
      }
      articles(data05).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsInner01 = data.rows
        }
      })

      //科技创新
      let data06 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0152',
        pageNum: 1,
        pageSize: 5
      }
      getAllArtListByParentUuid(data06).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsInner02 = data.rows
        }
      })

      //学习园地
      let data07 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0157',
        pageNum: 1,
        pageSize: 5
      }
      getAllArtListByParentUuid(data07).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsInner03 = data.rows
        }
      })
      //党群工作
      let data08 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0155',
        pageNum: 1,
        pageSize: 5
      }
      getAllArtListByParentUuid(data08).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsInner04 = data.rows
        }
      })

      //企业文化
      let data09 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0154',
        pageNum: 1,
        pageSize: 5
      }
      getAllArtListByParentUuid(data09).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsInner05 = data.rows
        }
      })

      //人力资源
      let data10 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0156',
        pageNum: 1,
        pageSize: 5
      }
      getAllArtListByParentUuid(data10).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsInner06 = data.rows
        }
      })

      //专题专栏
      let data11 = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01600001',
        pageNum: 1,
        pageSize: 5
      }
      articles(data11).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.newsInner07 = data.rows
        }
      })
    },

    // 精品工程
    bannerPoint() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '0153',
        pageNum: 1,
        pageSize: 30
      }
      picArticlesSecond(data).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeJpgcList = data.rows
          this.$nextTick(() => {
            _this.mySwiper = new Swiper('.bannerPoint', {
              // autoplay: {
              //   delay: 0,
              //   disableOnInteraction: false,
              // },
              speed: 5000,
              autoplay: 1,
              loop: true,
              slidesPerView: 4,
              spaceBetween: 15,
              // navigation: {
              //   nextEl: '.swiper-button-next-jpgc',
              //   prevEl: '.swiper-button-prev-jpgc',
              //   hideOnClick: true,
              // },
              prevButton: '.swiper-button-prev-jpgc',
              nextButton: '.swiper-button-next-jpgc',
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
            // *****以下代码是用来解决swiper鼠标悬停时延迟的问题
            let nextTransForm = ''
            // 轮播图从暂停位置移动到原本应到的位置所用的时间
            let nextTime = 0

            // 鼠标悬浮暂停轮播
            _this.mySwiper.container[0].onmouseover = function () {
              nextTransForm = document
                .getElementsByClassName('bannerPoint')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform
              // 轮播图原本应移动到的位置
              let nextTransPosition =
                -1 *
                parseInt(
                  document
                    .getElementsByClassName('bannerPoint')[0]
                    .getElementsByClassName('swiper-wrapper')[0]
                    .style.transform.split('translate3d(')[1]
                    .split('px')[0]
                )

              // 鼠标悬浮时时轮播图位置
              let nowTransPosition =
                -1 *
                parseInt(
                  window
                    .getComputedStyle(
                      document.getElementsByClassName('bannerPoint')[0].getElementsByClassName('swiper-wrapper')[0],
                      false
                    )['transform'].split('1, ')[2]
                    .split(',')[0]
                )
              // 存放鼠标悬浮时轮播图的真实transform属性（非行内属性）
              let nowTransForm = window.getComputedStyle(
                document.getElementsByClassName('bannerPoint')[0].getElementsByClassName('swiper-wrapper')[0],
                false
              )['transform']
              // 计算轮播图从暂停位置移动到原本应到的位置所用的时间（370是我自定义的每个slide的宽度）
              nextTime = 5500 * ((nextTransPosition - nowTransPosition) / 370)
              // 改变行内transform属性
              document
                .getElementsByClassName('bannerPoint')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nowTransForm
              // 不写也没关系
              document
                .getElementsByClassName('bannerPoint')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = '0ms'
              _this.mySwiper.stopAutoplay()
            }
            // 鼠标离开轮播图开始轮播
            _this.mySwiper.container[0].onmouseout = function () {
              // 恢复原样
              document
                .getElementsByClassName('bannerPoint')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transform = nextTransForm
              document
                .getElementsByClassName('bannerPoint')[0]
                .getElementsByClassName('swiper-wrapper')[0].style.transitionDuration = nextTime + 'ms'
              _this.mySwiper.startAutoplay()
            }
          })
        }
      })
    },

    // 集团期刊
    bannerNewPaper() {
      var _this = this
      let data = {
        entTApplicationUuid: _this.webId,
        channelUuid: '01600005',
        pageNum: 1,
        pageSize: 20
      }
      picArticles(data).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homenewPaper = data.rows
          this.$nextTick(() => {
            new Swiper('.Paper', {
              // autoplay: {
              //   delay: 3000,
              //   disableOnInteraction: false,
              // },
              speed: 3000,
              autoplay: 500,
              loop: true,
              slidesPerView: 2,
              spaceBetween: 20,
              // navigation: {
              //   nextEl: '.swiper-button-next-Paper',
              //   prevEl: '.swiper-button-prev-Paper',
              //   hideOnClick: true,
              // },
              prevButton: '.swiper-button-prev-Paper',
              nextButton: '.swiper-button-next-Paper',
              observer: true, //修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, //修改swiper的父元素时，自动初始化swiper
              autoplayDisableOnInteraction: false //用户操作swiper之后重新启动autoplay
            })
          })
        }
      })
    },

    // 中部banner
    bannerImg() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        advertType: 3
      }
      getAdvert(data).then((res) => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.homeBannList = data
          this.$nextTick(() => {
            new Swiper('#homeBann', {
              // direction : 'vertical',
              loop: true,
              // autoplay: {
              //   delay: 4000,
              //   disableOnInteraction: false
              // },
              speed: 200,
              autoplay: 3000,
              observer: true,
              observeParents: true,
              observeSlideChildren: true,
              effect: 'fade',
              // pagination: {
              //   el: '.swiper-pagination-homeBanner',
              //   clickable: true,
              // },
              pagination: '.swiper-pagination-homeBanner',
              paginationClickable: true
            })
          })
        }
      })
    },

    mouseenterNewsHd(val) {
      var _this = this

      _this.activeNewsHd = val
    },
    mouseenterNewsList(val) {
      var _this = this

      _this.activeNewsList = val
    },
    mouseenterNewsList2(val) {
      var _this = this

      _this.activeNewsList2 = val
    },
    mouseenterNewsList3(val) {
      var _this = this

      _this.activeNewsList3 = val
    },

    mouseenterst(val) {
      var _this = this

      _this.activeNewli = val
    }
  }
}
</script>
<style scoped>
.home {
  width: 100%;
  height: auto;
}
.mainHome {
  margin-top: 40px;
  width: 100%;
  height: auto;
}
.wrap {
  width: 100%;
  margin: 0 auto;
  height: auto;
}
.homeNews {
  /* width: 1200px; */
  height: auto;
  margin: 0 auto;
}
.main_title {
  width: 100%;
  height: 63px;
  background: url(../assets/image/gsqj_6.jpg) no-repeat;
  background-position: center 30px;
  margin-bottom: 24px;
}
.main_title h3 {
  text-align: center;
  line-height: 1;
  font-weight: normal;
  font-size: 34px;
  color: #004f98;
}
.main_title h4 {
  text-align: center;
  line-height: 1;
  font-weight: normal;
  font-size: 18px;
  color: #0770ca;
  margin-top: 15px;
}
.homeNews .homeNewsHd {
  height: 37px;
  position: relative;
  color: #ffffff;
  width: 1200px;
  margin: 0 auto 42px auto;
}
.homeNewsHd .homeNewsHdInner {
  width: 163px;
  height: 35px;
  cursor: pointer;
  font-size: 20px;
  color: #0770ca;
  text-align: center;
  line-height: 35px;
  border: 1px solid #0770ca;
  margin: 0 13px;
  background-color: #ffffff;
}
.homeNewsHd .homeNewsHdInner a {
  width: 100%;
  height: 100%;
  color: #0770ca;
}
.homeNewsHdInner a:hover {
  background-color: #0770ca;
  color: #ffffff;
}
.homeNewsHdInner a.active {
  background-color: #0770ca;
  color: #ffffff;
}
.homeNewsHdInner.active {
  background-color: #0770ca;
  color: #ffffff;
}
.homeNewsHd span.active a {
  background-color: #0770ca;
  color: #fff;
}
.homePhotoNew {
  width: 596px;
  height: 342px;
  float: left;
}
.PhotoNew1 {
  width: 260px;
  height: 342px;
  float: left;
  margin-right: 38px;
  position: relative;
}
a {
  text-decoration: none;
}
.timeDiv {
  width: 57px;
  height: 56px;
  background-color: #333333;
  position: absolute;
  top: 0;
  left: 0;
}
.homePhotoNew .timeDiv h4 {
  font-size: 30px;
  color: #ffffff;
  text-align: center;
  font-weight: normal;
  line-height: 1;
  padding: 5px 0 3px 0;
  box-sizing: border-box;
}
.homePhotoNew a .timeDivYear {
  font-size: 12px;
  color: #ffffff;
  display: block;
  text-align: center;
  line-height: 1;
}
.homePhotoNew img {
  width: 260px;
  height: 195px;
  display: block;
}
.homePhotoNew a h4 {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #333333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
}
.homePhotoNew a p {
  font-size: 14px;
  color: #000000;
  line-height: 30px;
  height: 60px;
  overflow: hidden;
}
.homePhotoNew a span {
  display: block;
  width: 130px;
  height: 30px;
  background-color: #0770ca;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 30px;
  margin-top: 17px;
}
.PhotoNew1:hover {
  cursor: pointer;
}
.PhotoNew1:hover .h4title {
  color: rgb(7, 112, 202);
}
.PhotoNew1:hover .timeDiv {
  background-color: rgb(7, 112, 202);
  color: #fff;
}
.homeNewRight {
  width: 588px;
  height: 342px;
  float: right;
  margin-top: -10px;
}
.homeNewRight .news_list {
  width: 588px;
  height: auto;
}
.homeNewRight .news_list li {
  width: 566px;
  height: auto;
  cursor: pointer;
}

.homeNewRight .news_list li .homeNewList .NewListTitle {
  width: 542px;
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
  background: url(../assets/image/gsqj_5.jpg) no-repeat;
  background-position: 0 center;
}
.homeNewRight .news_list li .homeNewList .NewListTitle h4 {
  font-size: 14px;
  color: #666666;
  float: left;
  font-weight: normal;
  width: 410px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.homeNewRight .news_list li .homeNewList .NewListTitle .newsTime {
  font-size: 14px;
  color: #666666;
  float: right;
}
.homeNewRight .news_list li .homeNewList p {
  font-size: 14px;
  color: #666666;
  line-height: 30px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #d1d1d1;
  display: none;
  margin-bottom: 6px;
}
.homeNewRight .news_list li.active .homeNewList .NewListTitle {
  padding-left: 0 !important;
  background: none !important;
}
.homeNewRight .news_list li.active .homeNewList .NewListTitle .newsTime {
  display: none;
}
.homeNewRight .news_list li.active .homeNewList .NewListTitle h4 {
  font-size: 20px !important;
  color: #004e96 !important;
  width: 100% !important;
}
.homeNewRight .news_list li.active .homeNewList p {
  display: block;
}
/* 精品工程 */
.homeJpgc {
  width: 100%;
  height: 441px;
  background: url(../assets/image/gsqj_7.jpg) no-repeat;
  background-position: center center;
  position: relative;
}
.homeJpgc .main_title {
  width: 100%;
  height: 63px;
  background: url(../assets/image/gsqj_8.jpg) no-repeat;
  background-position: center 62px;
  margin-bottom: 40px;
  padding-top: 32px;
}
.homeJpgc .main_title h3 {
  text-align: center;
  line-height: 1;
  font-weight: normal;
  font-size: 34px;
  color: #ffffff;
}
.homeJpgc .main2 .main_title h4 {
  text-align: center;
  line-height: 1;
  font-weight: normal;
  font-size: 18px;
  color: #268ce4;
  margin-top: 15px;
}
.homeJpgc .main2_1 {
  width: 1200px;
  height: 215px;
  margin: 28px auto 0;
  position: relative;
}
.homeJpgc .bannerPoint .swiper-wrapper {
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
.homeJpgc .bannerPoint .swiper-slide .pic {
  height: 214px;
  overflow: hidden;
  margin: 0px 8px;
}
.homeJpgc .bannerPoint .swiper-slide .title {
  width: 270px;
  height: 40px;
  display: block;
  background: url(../assets/image/gsqj_5.png) repeat;
  text-align: left;
  font-size: 18px;
  color: #ffffff;
  padding: 0 11px;
  margin-top: -40px;
  box-sizing: border-box;
  margin-left: 9px;
}
.homeJpgc .swiper-button-next-jpgc {
  display: block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  cursor: pointer;
  background: url(../assets/image/gsqj_7.png) no-repeat;
  position: absolute;
  right: -50px;
  top: 110px;
}
.homeJpgc .swiper-button-prev-jpgc {
  display: block;
  width: 40px;
  height: 40px;
  overflow: hidden;
  cursor: pointer;
  background: url(../assets/image/gsqj_6.png) no-repeat;
  position: absolute;
  left: -50px;
  top: 110px;
}
.homeJpgc .main2_m {
  width: 200px;
  height: 50px;
  position: relative;
  margin: 24px auto;
}
.homeJpgc .main2_m a {
  width: 88px;
  height: 24px;
  display: block;
  position: absolute;
  background: url(../assets/image/gsqj_8.png) no-repeat;
  bottom: 13px;
  left: 56px;
}
.homeJpgc .main2_m a:hover {
  animation: newshov 0.4s linear 1;
}
@keyframes newshov {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-80px);
  }
}

.NewList {
  width: 1200px;
  height: 300px;
  margin: 30px auto 0;
}
.NewListL {
  width: 357px;
  height: 300px;
  background-color: #ffffff;
  float: left;
}

.newTitle {
  line-height: 62px;
  height: 62px;
  position: relative;
  border-bottom: 1px solid #cccccc;
  background: url(../assets/image/gsqj_10.jpg) no-repeat;
  background-position: left center;
}
.NewsLTitle {
  z-index: 5;
  display: inline-block;
  height: 62px;
  zoom: 1;
  padding-left: 19px;
}
.NewsLTitle a {
  float: left;
  height: 62px;
  cursor: pointer;
  font-size: 24px;
  color: #666666;
  text-align: center;
  line-height: 62px;
  position: relative;
  margin-right: 2px;
}
.NewsLTitle a.active {
  line-height: 62px;
  color: #004f98;
}
.NewsLTitle a:hover {
  line-height: 62px;
  color: #004f98;
}
.newTitle .more {
  font-size: 16px;
  color: #004e96;
  margin-left: 20px;
  display: inline-block;
  float: right;
}
.newTitle .more a {
  color: #004e96;
}
.newTitle .more a:hover {
  color: #0074b7;
}
.newTitle .span1 {
  font-size: 24px;
  color: #666666;
  float: left;
  margin: 0px 10px 0 25px;
}
.NewsLInner {
  width: 357px;
  left: 0px;
  top: 0px;
}
.newsInner {
  width: 357px;
  height: auto;
  margin-top: 11px;
}
.newsInner li {
  width: 357px;
  cursor: pointer;
  line-height: 41px;
}
.newsInnerList h3 {
  font-size: 18px;
  color: #666666;
  float: left;
  font-weight: normal;
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 26px;
  background: url(../assets/image/gsqj_11.jpg) no-repeat;
  background-position: left center;
}
.newsInnerList .newsInnerTime {
  font-size: 18px;
  color: #666666;
  float: right;
}
.NewListL2 {
  width: 357px;
  height: 300px;
  float: left;
  margin: 0 64px;
  background-color: #ffffff;
}
.NewListL3 {
  width: 357px;
  height: 300px;
  background-color: #ffffff;
  float: right;
}
.newsInnerList h3:hover {
  color: #004f98;
}
.homeBanner {
  width: 1200px;
  height: 120px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}
.homeBanner img {
  width: 1200px;
  height: 120px;
  display: block;
}
.homeBanner .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  background: #000;
  opacity: 0.2;
  border-radius: 0;
}
.homeBanner .swiper-pagination-homeBanner {
  text-align: right;
}
.homeBanner .swiper-pagination-bullet-active {
  opacity: 1;
  background: red;
}
.NewsLInn {
  width: 165px;
  height: 85px;
  background-color: #e5e5e5;
  margin-bottom: 15px;
}
.NewsLInn span {
  width: 39px;
  height: 41px;
  display: block;
  margin: 9px auto;
}
.NewsLInn h4 {
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 1;
  font-weight: normal;
}
.NewsLInn1 span {
  background: url(../assets/image/gsqj_9.png) no-repeat;
}
.NewsLInn2 span {
  background: url(../assets/image/gsqj_10.png) no-repeat;
}
/* .NewsLInn3 {
  background: url(../assets/image/gsqj_21.png) no-repeat;
  background-size: 100% 100%;
} */
.NewsLInn3 span {
  background: url(../assets/image/gsqj_11.png) no-repeat;
}
.NewsLInn4 span {
  background: url(../assets/image/gsqj_12.png) no-repeat;
}
.NewsLInn:hover {
  background-color: #004e96;
}
.NewsLInn:hover h4 {
  color: #fff;
}
.NewsLInn1:hover span {
  background: url(../assets/image/gsqj_13.png) no-repeat;
}
.NewsLInn2:hover span {
  background: url(../assets/image/gsqj_14.png) no-repeat;
}
.NewsLInn3:hover span {
  background: url(../assets/image/gsqj_15.png) no-repeat;
}
.NewsLInn4:hover span {
  background: url(../assets/image/gsqj_16.png) no-repeat;
}
.NewsLPaper {
  position: relative;
  width: 352px;
  height: 218px;
  margin: 22px auto 0;
}
.Paper {
  height: 214px;
  width: 286px;
  padding: 0 6px;
}
.Paperimg {
  width: 135px;
  height: 180px;
  display: block;
}
.homeReport {
  width: 1200px;
  height: 80px;
  margin: 15px auto;
}
.main6 {
  width: 100%;
  height: 236px;
  background-color: #eeeeee;
}
.main6_1 {
  width: 1200px;
  height: 336px;
  margin: 0 auto;
}
.main6_left {
  width: 563px;
  height: 180px;
  margin-top: 28px;
}

.main6_left img {
  width: 288px;
  height: 180px;
  float: left;
  display: block;
}
.main6_left1 {
  width: 275px;
  height: 180px;
  background-color: #2c87d6;
  float: right;
  position: relative;
}
.main6_left1 h4 {
  font-size: 26px;
  color: #ffffff;
  margin: 28px 0 0 15px;
  font-weight: normal;
  line-height: 1;
}
.main6_left1 h5 {
  font-size: 22px;
  color: #03508a;
  margin: 22px 0 0 15px;
  line-height: 1;
}
.main6_left1 span {
  width: 76px;
  height: 21px;
  display: block;
  position: absolute;
  bottom: 29px;
  right: 29px;
  background: url(../assets/image/gsqj_22.png) no-repeat;
}
.main6_left1 span:hover {
  animation: spanplay 0.4s linear 1;
}
@keyframes spanplay {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-50px);
  }
}
.main6_right {
  width: 563px;
  height: 180px;
  margin-top: 28px;
}
.main6_right img {
  width: 288px;
  height: 180px;
  float: left;
  display: block;
}
.main6_right_new img {
  height: 100%;
  width: auto;
  margin-left: 65px;
}
.main6_right1 {
  width: 275px;
  height: 180px;
  background-color: #8fd49e;
  float: right;
  position: relative;
}

.main6_right1 h4 {
  font-size: 26px;
  color: #ffffff;
  margin: 28px 0 0 15px;
  font-weight: normal;
  line-height: 1;
}
.main6_right1 h5 {
  font-size: 22px;
  color: #53a064;
  margin: 22px 0 0 15px;
  line-height: 1;
}
.main6_right1 span {
  width: 76px;
  height: 21px;
  display: block;
  position: absolute;
  bottom: 29px;
  right: 29px;
  background: url(../assets/image/gsqj_22.png) no-repeat;
  /* transition: margin-right 0.5s linear; */
  /* transform: translateX(30px); */
}
/* .main6_right1 span:hover{
   transform:translateX(0px);
   transition-delay: 0.4s;
} */

.main6_right1 span:hover {
  animation: spanshow 0.4s linear 1;
}
@keyframes spanshow {
  from {
    transform: translateX(0px);
  }
  to {
    transform: translateX(-50px);
  }
}
.main7 {
  width: 1162px;
  height: 45px;
  padding: 6px 18px;
  margin: 17px auto 17px;
  border: 1px solid #cccccc;
}
.main7Inner {
  width: 227px;
  height: 45px;
  padding: 0 42px 0 41px;
  margin: 0 0;
  border-right: 1px solid #cccccc;
  float: left;
}
.main7Div {
  width: 215px;
  height: 27px;
  margin: 7px 0;
  border: 2px solid #cccccc;
  background: url(../assets/image/gnmzj_33.jpg) no-repeat;
  position: relative;
  font-size: 14px;
  color: #555555;
  line-height: 27px;
  padding-left: 8px !important;
  cursor: pointer;
  background-position: 197px center;
}
.main7Div select {
  height: 27px;
  font-size: 14px;
  color: #555555;
  padding-left: 8px;
  outline: medium;
  cursor: pointer;
  border: none;
  width: 88%;
}
.swiper-button-prev-Paper {
  display: block;
  width: 27px;
  height: 54px;
  overflow: hidden;
  cursor: pointer;
  background: url(../assets/image/gsqj_17.png) no-repeat;
  position: absolute;
  left: -10px;
  top: 80px;
}
.swiper-button-next-Paper {
  display: block;
  width: 27px;
  height: 54px;
  overflow: hidden;
  cursor: pointer;
  background: url(../assets/image/gsqj_18.png) no-repeat;
  position: absolute;
  right: -10px;
  top: 80px;
}
</style>
